import React, { useEffect, useMemo, useRef, useState, useContext } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import moment from "moment";
import { LS_AUTHORITY_KEY } from "../constants/common";
import ReportService from "../service/ReportService";
import { toast } from "react-toastify";
import { BiX, BiTrash } from "react-icons/bi";
const ImageUploadPopup = ({ t, onPopupClose, onImageSelection }) => {
	const authority = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));

	const [show, setShow] = useState(true);
	const [imageList, setImageList] = useState([]);
	const fileChooserRef = useRef();
	const [loaderdisplay, setLoaderDisplay] = useState(false)
	useEffect(() => {
		fetchImages();
	}, []);

	const fetchImages = () => {

		ReportService.listImages().then(res => {
			if (res.status !== 200) return;

			setImageList(res.data);

		}).catch(err => { })
	};

	const handleClose = () => {
		setShow(false);
		onPopupClose();
	};

	const onImageUpload = (e) => {
		setLoaderDisplay(true);
		e.preventDefault();
		const formData = new FormData();
		formData.append("file", e.target.files[0]);
		ReportService.uploadImage(formData)
			.then((response) => {
				setLoaderDisplay(response.data.id)
				toast.success(response.data, {
					position: toast.POSITION.TOP_RIGHT,
				});
				fetchImages();
			})
			.catch((error) => { })
			.finally(() => {
				setLoaderDisplay(false);
			});
	};
	const deleteImage = (id) => {
		ReportService.deleteImage(id)
			.then((response) => {
				toast.success("Image deleted successfully", {
					position: toast.POSITION.TOP_RIGHT,
				});
				fetchImages();
			})
			.catch((error) => { });
	};

	const groupedImages = useMemo(() => {
		const groups = {};
		[...imageList]
			.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate))
			.forEach((image) => {
				const monthKey = moment(image.createdDate).format("YYYY-MM");
				if (!groups[monthKey]) {
					groups[monthKey] = {
						label: moment(image.createdDate).format("MMMM YYYY"),
						images: [],
					};
				}
				groups[monthKey].images.push(image);
			});
		return Object.keys(groups)
			.sort((a, b) => (a < b ? 1 : -1))
			.map((monthKey) => groups[monthKey]);
	}, [imageList]);

	return (
		<>

			<Modal
				show={show}
				onHide={handleClose}
				size="xl"
				aria-labelledby="contained-modal-title-vcenter"
				centered>
				<Modal.Header closeButton>
					 <Modal.Title as="h5">
						{t("InsertImage.label")}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>

					<Form noValidate className="Insert_Imageuploadbox">
						<input hidden
							ref={fileChooserRef}
							type="file"
							id="imageUpload"
							accept=".png, .jpg, .jpeg"
							onChange={(e) => onImageUpload(e)}
							onClick={(e) => {
								e.target.value = null;
							}}
						/>
						<Button variant="secondary" onClick={() => fileChooserRef.current.click()}
							className="sbmBtn ">
							{t("UploadNewImage.label")}
						</Button>
						{loaderdisplay && (
							<div
								className="spinner-Body">
								<div className="spinner-8"></div>
							</div>
						)}
					</Form>
					<div className="Insert_ImageScrollArea">
						{imageList.length === 0 && <div className="alert alert-info">{t('NoImagesInLibrary.label')}</div>}
						{
							groupedImages.map((group) => (
								<div className="Insert_ImageMonthGroup" key={group.label}>
									<h6 className="Insert_ImageMonthHeader">{group.label}</h6>
									<div className="Insert_ImageRow">
										{
											group.images.map((image) => (
												<div className="Insert_ImageThumbnail" key={image.id}>
													<span onClick={() => deleteImage(image.id)}><BiTrash /></span>
													<div className="Insert_ImageThumbnail_inner" onClick={() => onImageSelection(image.ref)}>
														<img src={ReportService.getImage(image.ref)} width='150' height='150' />
													</div>
												</div>
											))
										}
									</div>
								</div>
							))
						}
					</div>
				</Modal.Body>
			</Modal>
		</>
	);
};
export default withTranslation()(ImageUploadPopup);
